import { render, staticRenderFns } from "./PageImportContract.vue?vue&type=template&id=3de48fd0&scoped=true&"
import script from "./PageImportContract.vue?vue&type=script&lang=js&"
export * from "./PageImportContract.vue?vue&type=script&lang=js&"
import style0 from "./PageImportContract.vue?vue&type=style&index=0&id=3de48fd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de48fd0",
  null
  
)

export default component.exports